<template>
    <base-modal :adaptive="true" height="auto" width="700" :name="name" v-cloak>
        <div class="p-4 lg:p-8">
            <iframe id="cookie-policy-iframe" class="w-full max-h-screen" style="height: 700px"></iframe>
        </div>
    </base-modal>
</template>
<script>
    import { mapGetters } from 'vuex'
    import axios from 'axios'

    export default {
        data() {
            return {
                name: 'cookie-policy-modal',
            }
        },

        computed: {
            ...mapGetters('general', ['_']),
            ...mapGetters('modal', ['isModalVisible']),

            isVisible() {
                return this.isModalVisible(this.name);
            },
        },

        watch: {
            isVisible(visible) {
                if (visible) {
                    this.fetchTerms();
                }
            }
        },

        methods: {
            fetchTerms() {
                this.termsFallbackUrl = null;

                 axios({
                    method: 'get',
                    url: '/cookies?for-iframe=1'
                }).then(({data}) => {
                    let iframe = document.getElementById('cookie-policy-iframe');
                    iframe.srcdoc = data;
                });
            },
        }
    }
</script>
